import { z } from "zod";
import { BaseOutputSchema } from "./BaseOutput";

export const ExtractedDataItemSchema = z.object({
    label: z.string(),
    value: z.string(),
});

export type ExtractedDataItem = z.infer<typeof ExtractedDataItemSchema>;

export const UploadIdCardOutputSchema = BaseOutputSchema.extend({
    sessionId: z.string().nullish(),
    isValid: z.boolean(),
    validationMessage: z.string().nullish(),
    frontFileId: z.string().nullish(),
    backFileId: z.string().nullish(),
    extractedData: z.array(ExtractedDataItemSchema).nullish(),
    isBackSide: z.boolean().nullish(),
});

export type UploadIdCardOutput = z.infer<typeof UploadIdCardOutputSchema>;

